import {Box, Flex} from 'rebass/styled-components';

const CatalogItem = ({children, sx}) => {
  return (
    <Box
      as="flex"
      justifyContent="space-between"
      //flexGrow="1"
      width={[1 / 2, 1 / 3, 1 / 3]}
      p={4}
      sx={{
        position: 'relative',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default CatalogItem;
